export var IdentityVerificationSheetEventsEnum;
(function (IdentityVerificationSheetEventsEnum) {
    IdentityVerificationSheetEventsEnum["Loaded"] = "identityVerificationSheetLoaded";
    IdentityVerificationSheetEventsEnum["FailedToLoad"] = "identityVerificationSheetFailedToLoad";
    IdentityVerificationSheetEventsEnum["Completed"] = "identityVerificationSheetCompleted";
    IdentityVerificationSheetEventsEnum["Canceled"] = "identityVerificationSheetCanceled";
    IdentityVerificationSheetEventsEnum["Failed"] = "identityVerificationSheetFailed";
})(IdentityVerificationSheetEventsEnum || (IdentityVerificationSheetEventsEnum = {}));
//# sourceMappingURL=identity-verification-sheet-events.enum.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@capacitor-community/stripe/dist/esm/identityverificationsheet/identity-verification-sheet-events.enum.js
// module id = null
// module chunks = 